import { Component } from '@angular/core';
import {TabsService} from "../../../services/tabsService";
import {PointsService} from "../../../services/points.service";
import {UserSettingsService} from "../../../services/userSettings.service";
import {GritCondition, GritFilter} from "../../../models/grit/grit.filter";
import {FilterMode, GritFeatureFilterService} from "../../../services/grit/grit.feature-filter.service";
import {InterferenceTestModel} from "../../../models/grit/grit.interference-test-model";
import {GritProjectService} from "../../../services/grit/grit.project.service";
import {GritOption} from "../../../models/grit/grit.model";

@Component({
  selector: 'app-feature-filter',
  templateUrl: './feature-filter.component.html',
  styleUrls: ['./feature-filter.component.scss'],
  standalone: false
})
export class FeatureFilterComponent {

  tab = this.featureFilterService.tab;

  constructor(protected featureFilterService: GritFeatureFilterService,
              protected tabsService: TabsService,
              protected pointsService : PointsService,
              protected userSettingsService : UserSettingsService,
  ) {}

  getDisplay(array: GritOption<string>[], value: string){
    return array.find(o => o.value === value.toString()).display ?? "";
  }

  getConditionString(name: string, conditions: GritCondition[]){
    let filter = this.tab.current.filters.find(filter => filter.display === name);

    if (filter && Object.hasOwn(filter.value, "toString")){
      return filter?.value.toString(conditions)
    }
    else{
      let str = "";
      conditions.forEach(condition => str += condition.value.toString() + "...")
      return str.slice(0, str.length - 3);
    }
  }



  protected readonly InterferenceTest = InterferenceTestModel;
  protected readonly GritProjectService = GritProjectService;
  protected readonly FilterMode = FilterMode;
}
